<div class="inside-container" *ngIf="userDetails">
    <div fxLayout="row">
        <div fxFlex="70" fxLayoutAlign="start center">
            <h3 class="tab-header" i18n="@@badf94777907e100410a69d21ca4ff8f5499800c"
                t="badf94777907e100410a69d21ca4ff8f5499800c">Document Details</h3>
            <a target="_blank" [href]="helpUrl">
                <tsl-icon size="small" class="header-help-icon">help</tsl-icon>
            </a>
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="5px">
        <p *ngIf="userDetails.isSupplier">
            <span i18n="@@3ae001ac6ddf67cedcb9f544f3c340f36990be92" t="3ae001ac6ddf67cedcb9f544f3c340f36990be92">The
                Documents Tab is available for users to manage their organizations different documents provided to
                Tesla. Changes made to this page will go to the Tesla for review and approval for validation
                purposes.</span><br />
            <b i18n="@@3175fb1379d3ce0e122b782a8a41f6ac1c07ade7" t="3175fb1379d3ce0e122b782a8a41f6ac1c07ade7">Please
                Note:</b>
            <span i18n="@@b9c0d538653c1117cd18371c45ff6f3fda3e05a8" t="b9c0d538653c1117cd18371c45ff6f3fda3e05a8">Your
                Primary Contact will receive emails in regards to rejection or approval of any changes.</span>
        </p>
        <p *ngIf="userDetails.isTeslaUser">
            <span i18n="@@18243480d01fab9f06f47aa3cb76888138a5e2f6" t="18243480d01fab9f06f47aa3cb76888138a5e2f6">The
                Documents Tab is available to manage organizations different documents provided to Tesla. </span><br />
            <span i18n="@@7445659469e1a219ce372682e7d182960a3c0dc8" t="7445659469e1a219ce372682e7d182960a3c0dc8">Please
                go to </span><a target="_blank" [href]="wsmUrl">warp supplier master</a>
            <span i18n="@@825d85e10720d106f01e81354a2126251f7beba4" t="825d85e10720d106f01e81354a2126251f7beba4">to make
                any changes.</span>
        </p>
        <p *ngIf="showCMTUrl">
            <span i18n="@@06e3ef7a1f084e3171d904619ae3c1e75e8f7979" t="06e3ef7a1f084e3171d904619ae3c1e75e8f7979">If you
                have additional questions in regards to this data, click on the hyperlink provided to submit a
                inquiry to the Tesla Vendor Validation Team. </span><a [href]="cmtUrl">CMT</a>
        </p>
    </div>

    <!-- grid start -->
    <table tsl-table tslSort [dataSource]="datasource" (tslSortChange)="onSortChange($event)">
        <!-- category Column -->
        <ng-container tslColumnDef="category">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@Type" t="Type">Type</th>
            <td tsl-cell *tslCellDef="let row">
                <div *ngIf="getDocumentType(row.abbreviation); else empty">
                    {{ getDocumentType(row.abbreviation) }}
                </div>
            </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container tslColumnDef="name">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@Name" t="Name">Name</th>
            <td tsl-cell *tslCellDef="let row">
                <a class="link" *ngIf="
                        this.userDetails &&
                        this.isPrimary === true &&
                        (row.permission == 'ReadWrite' || row.permission == 'Read')
                    " (click)="onDownloadFile(row, '1')">{{ row.contractName }}{{ row.externalStorageDocumentExtension
                    }}</a>
                <span *ngIf="
                        (this.userDetails && this.isTeslaUser === true) ||
                        (this.isPrimary === false && row.permission == 'Read')
                    ">{{ row.contractName }}{{ row.externalStorageDocumentExtension }}</span>
            </td>
        </ng-container>

        <!-- Start Column -->
        <ng-container tslColumnDef="start">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@3e6acd589d8b82cafd8546409da0a36469d297a0"
                t="3e6acd589d8b82cafd8546409da0a36469d297a0">Start Date</th>
            <td tsl-cell *tslCellDef="let row">
                <div *ngIf="row.effectiveDate; else empty">
                    {{ row.effectiveDate | date }}
                </div>
            </td>
        </ng-container>

        <!-- End Column -->
        <ng-container tslColumnDef="expiry">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@41d055ec9cef3afb116c3118c2244ee66c895fbb"
                t="41d055ec9cef3afb116c3118c2244ee66c895fbb">Expiration Date</th>
            <td tsl-cell *tslCellDef="let row">
                <span *ngIf="isExpired(row)" i18n="@@ffde7468d7b5cad6990095ed68ddee3d67cd02f8"
                    t="ffde7468d7b5cad6990095ed68ddee3d67cd02f8">Expired</span>
                <span *ngIf="!isExpired(row)">{{ row.expirationDate | date }}</span>
            </td>
        </ng-container>

        <!-- Signature Column -->
        <ng-container tslColumnDef="signature">
            <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@2ab79e0ca9186d7588d974b34b0872432d12b32d"
                t="2ab79e0ca9186d7588d974b34b0872432d12b32d">Signature Date</th>
            <td tsl-cell *tslCellDef="let row">
                <div *ngIf="row.signedDate; else empty">
                    {{ row.signedDate | date }}
                </div>
            </td>
        </ng-container>

        <!-- Operation Column -->
        <ng-container tslColumnDef="status">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@81b97b8ea996ad1e4f9fca8415021850214884b1"
                t="81b97b8ea996ad1e4f9fca8415021850214884b1">Status</th>
            <td tsl-cell *tslCellDef="let row">
                <div *ngIf="row.contractStatusDisplayValue; else empty">{{ row.contractStatusDisplayValue }}</div>
            </td>
        </ng-container>

        <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
        <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>

        <ng-template #empty>
            <tsl-icon>maximize</tsl-icon>
        </ng-template>
    </table>

    <!-- grid pagination -->
    <tsl-pagination showFirstLastButtons [pageSizeOptions]="pageSizeOptions" [total]="total" [pageSize]="pageSize"
        [pageIndex]="pageIndex" (pageChange)="onPageChange($event)"
        [itemsPerPageLabel]="translateService.get('ItemsPerPage')">
    </tsl-pagination>
</div>